module.exports = "/_next/static/images/logo-aman-2-c6c88c52f4abdc69ec0b928602dc3552.png";